import { PayPalButtons } from "@paypal/react-paypal-js";
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import { useMercadopago } from 'react-sdk-mercadopago';
import styles from './main.module.css';
import fbLogo from '../assets/images/fb.svg';
import igLogo from '../assets/images/ig.svg';
import { useEffect } from "react";
import { axios, getAxiosConfig } from '../utils/apiUtils';
import unicefLogo from '../assets/images/mini-logo-unicef-blanco.png';


const ChoosePlan = (props) => {
    const params = queryString.parse(props.location.search);

    const mercadopago = useMercadopago.v2(process.env.REACT_APP_MERCADO_PAGO_PUBLIC_KEY, {
        locale: 'es-CL',
    });

    const onPayPalApproval = (data, actions) => {

    };

    const getPayPalOrder = (giftAmount) => {

    };

    const getProductFromServer = (productTitle, containerId) => {
        axios.post(
            `${process.env.REACT_APP_API_URL}/payments/gifts/mercadopago/create_preference`,
            {
                product: productTitle,
                from: params.from
            },
            getAxiosConfig(),
        )
        .then((preferenceResponse) => {
            mercadopago.checkout({
                preference: {
                    id: preferenceResponse.data.mercadoPagoId
                },
                render: {
                    container: `.${containerId}`,
                    label: 'Comprar',
                }
            })
        }).catch((mercadoPagoError) => {
            console.error(`Mercado pago error > ${mercadoPagoError}`)
        });
    }

    useEffect(() => {
        if (mercadopago) {
            getProductFromServer('Trimestral', 'gift1');
            getProductFromServer('Semestral', 'gift2');
            getProductFromServer('Anual', 'gift3');            
        }else{
            console.error('No mercado pago object')
        }
    }, [mercadopago])

    return (
        <>
        <header className={`fixed-top ${styles.navbarRegala}`}>
            <nav className={`navbar navbar-expand `} aria-label="Eighth navbar example">
                <div className={`container d-flex flex-column flex-lg-row ${styles.navbarContainer}`}>
                    <a className={`navbar-brand ${styles.navbarBrand}`} href="/">
                        Hagamos Cosas Juntos
                    </a>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarChungungo"
                    aria-controls="navbarChungungo" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className={`collapse ${styles.collapse} navbar-collapse`}>
                        <ul className="navbar-nav ml-lg-auto">
                            <li className={`nav-item ${styles.navbarBtn}`}>
                                <a className="nav-link" href="/#">Inicio</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </header>

        <section className={`${styles.sectionPlan}`}>
            <div className={`row ${styles.rowFixed}`}>
                <div className={`col-md-12 text-center ${styles.planCardsContainer}`}>
                    <h3>1.- Elige y Paga Un Plan Chungungo Para Regalar</h3>
                    <div className={`${styles.planCardContainer}`}>
                        <div className={`${styles.planCard}`}>
                        
                            <h4>Trimestral</h4>
                            <span>$20.000</span>
                            <p>Suscripción por 3 meses a partir de fecha de activación.</p>
                            <div
                                style={{
                                    padding: 16,
                                    marginBottom: 16,
                                }}
                            >
                                <div className="gift1"></div>
                            </div>
                        </div>
                        
                    
                        <div className={`${styles.planCard}`}>
                            <h4>Semestral</h4>
                            <span>$40.000</span>
                            <p>Suscripción por 6 meses a partir de fecha de activación.</p>
                            <div
                                style={{
                                    padding: 16,
                                    marginBottom: 16,
                                }}
                            >
                                <div className="gift2"></div>
                            </div>
                        </div>
                        <div className={`${styles.planCard}`}>
                            <h4>Anual</h4>
                            <span>$75.900</span>
                            <p>Suscripción por 12 meses a partir de fecha de activacion. </p>
                            <div
                                style={{
                                    padding: 16,
                                    marginBottom: 16,
                                }}
                            >
                                <div className="gift3"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={`row ${styles.rowFixed}`}>
                <div className="col-md-12 text-center">
                    <p className={`${styles.planText}`}>Elige un plan de regalo y haz click en "Comprar". Serás derivado a la plataforma segura de Mercado Pago para realizar la transacción y luego de vuelta a este sitio para continuar con el proceso. </p>
                </div>
            </div>
        </section>


        <footer className={`${styles.footer}`}>
            <div className="container">
            <div className="row">
                <div className="col-12 text-center">
                <ul className="nav justify-content-center">
                    <li className="nav-item">
                    <a className="nav-link" href="/terms_and_conditions">Términos y Condiciones</a>
                    </li>
                    <li className="nav-item">
                    <a className="nav-link" href="/about">Acerca de</a>
                    </li>
                    <li className="nav-item">
                    <a className="nav-link" href="/faq">Preguntas Frecuentes</a>
                    </li>
                </ul>
                <ul className="nav justify-content-center mb-5">
                    <li className="nav-item">
                    <a className="nav-link" href="https://www.facebook.com/somoschungungo" target="_blank" rel="noreferrer"><img src={fbLogo} alt="Facebook" /></a>
                    </li>
                    <li className="nav-item">
                    <a className="nav-link" href="https://www.instagram.com/chungungo_com" target="_blank" rel="noreferrer"><img src={igLogo} alt="Instagram" /></a>
                    </li>
                </ul>
                <small className="text-muted">Todos los derechos reservados© 2021 Chungungo SPA.</small>
                </div>
            </div>
            </div>
            <div className={`${styles.unicef}`}>
                <img src={unicefLogo} alt="Patrocinio Unicef" />
            </div>
        </footer>
        
        </>


    )

}

export default withRouter(ChoosePlan);